import { pluginFactory } from '@/plugins/plugin'
import Datasets, { TYPE } from './Datasets.vue'
import services from '@/services'
import i18n from './i18n'

services.translation.init(i18n, { overwrite: false })

const DatasetsPlugin = pluginFactory({
  components: { Datasets }
})

export { DatasetsPlugin, Datasets, TYPE }
export default Datasets
